import type { BoardModelKind } from "./kind";
import type { BoardModelDebugMeasurable } from "./measurable";

/** Class-name chip anchor inside the debug outline (inset from edges). */
export type BoardModelDebugLabelPlacement =
  | "top-left"
  | "top-center"
  | "top-right"
  | "bottom-left"
  | "bottom-center"
  | "bottom-right";

const DEFAULT_PLACEMENT: BoardModelDebugLabelPlacement = "top-left";

/** Per-kind defaults; measurables may override via `labelPlacement`. */
const LABEL_PLACEMENT_BY_KIND: Partial<
  Record<BoardModelKind, BoardModelDebugLabelPlacement>
> = {
  CharacterGroup: "top-right",
  CharacterPortrait: "bottom-center",
  Location: "bottom-left",
  LocationGroup: "top-left",
  LocationPrimary: "bottom-left",
  LocationSecondary: "bottom-left",
};

export function labelPlacementForBoardModel(
  kind: BoardModelKind,
): BoardModelDebugLabelPlacement {
  return LABEL_PLACEMENT_BY_KIND[kind] ?? DEFAULT_PLACEMENT;
}

export function resolveBoardModelDebugLabelPlacement(
  measurable: Pick<BoardModelDebugMeasurable, "kind" | "labelPlacement">,
): BoardModelDebugLabelPlacement {
  return measurable.labelPlacement ?? labelPlacementForBoardModel(measurable.kind);
}

export function labelPlacementClass(
  placement: BoardModelDebugLabelPlacement,
): string {
  return `board-model-debug__label--${placement}`;
}
